import "../../styles/atoms.scss";
import SvgIcn from "../../data/IconCompo";
import { useState } from "react";

const Buttonz = ({
  iconL,
  iconR,
  hoverL,
  hoverR,
  children,
  className,
  to,
  onClick,
  label,
  label2,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <a
      href={to || null}
      className={`button ${className || ""}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
    >
      {iconL && <SvgIcn name={isHovered && hoverL ? hoverL : iconL} />}
      {label && <span>{label}</span>}
      {label2}
      {children}
      {iconR && <SvgIcn name={isHovered && hoverR ? hoverR : iconR} />}
    </a>
  );
};

export default Buttonz;
